


















































































import { Vue, Component } from "@/shared/vuepack";
import * as umb from "@/shared/umbUrls";
import { AppBrowserTarget, isMobileApp, openUrl } from "@/shared/mobileHelper";

@Component({
  components: {
  }
})
export default class UmbForms extends Vue {
  UmbUrls = umb;

  clickLink (event) {
    if (isMobileApp()) {
      openUrl(event.currentTarget.href, AppBrowserTarget.system);
    } else window.open(event.currentTarget.href, event.currentTarget.target);
  }
}
